exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shade{background:#333;opacity:.85;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1000}.shade-item{z-index:1001}.tour{position:absolute;background:#fff;width:400px;border-radius:4px;border:2px solid #afb5c2;padding:12px;color:#606266;line-height:1.4;font-size:14px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);text-align:left}.tour .title{font-weight:700;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1212aa8c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Tour.vue
// module id = 19mC
// module chunks = 0